import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import ROUTE_CONSTANT from "./routeconstants";

const PublicRoute = ({ children }) => {
  const { isAuthenticated, authChecked, isAdmin } = useSelector(
    (state) => state.user
  );
  const location = useLocation();

  if (!authChecked) return null;

  if (isAuthenticated) {
    return (
      <Navigate
        to={isAdmin ? ROUTE_CONSTANT.HOME_ADMIN : ROUTE_CONSTANT.HOME}
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
};

export default PublicRoute;
